const INITIAL_STATE = {
  game: null,
  prevGame: null,
};

const gameReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "CREATE_GAME":
      return { ...state, game: action.payload };
    case "DELETE_GAME":
      return { ...state, game: null };
    case "SAVE_PREV_GAME":
      return { ...state, prevGame: action.payload };
    default:
      return state;
  }
};

export default gameReducer;
